import { toast } from "sonner";
import { errMsg } from "./account";

const loadScript = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true);
  s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

export async function payWithRazorpay({ authed, payload, description, onSuccess, prefillName }) {
  const ok = await loadScript();
  if (!ok) return toast.error("Could not load Razorpay. Check your connection.");
  let order;
  try {
    order = await authed("post", "/payments/order", payload);
  } catch (e) {
    return toast.error(errMsg(e));
  }
  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Vivaah Royale",
    description,
    prefill: { name: prefillName || "" },
    theme: { color: "#D4AF37" },
    modal: { ondismiss: () => setTimeout(() => recoverPayments(authed, onSuccess), 3000) },
    handler: async (res) => {
      try {
        const d = await authed("post", "/payments/verify", res);
        toast.success("Payment successful");
        onSuccess?.(d.account);
      } catch (e) {
        toast.error(errMsg(e));
      }
    },
  });
  rzp.on("payment.failed", (r) => toast.error(r?.error?.description || "Payment failed"));
  rzp.open();
}

export async function recoverPayments(authed, onRecovered) {
  try {
    const r = await authed("post", "/payments/reconcile");
    if (r.recovered) { toast.success("We found and confirmed your recent payment"); onRecovered?.(r.account); }
  } catch {}
}
